// extracted by mini-css-extract-plugin
export default {"root":"StarDoubleIcon_root__aLMAi","starOne":"StarDoubleIcon_starOne__d8Ibc","starTwo":"StarDoubleIcon_starTwo__SLBPX","check":"StarDoubleIcon_check__IHGGb"};